import { msg } from '@lingui/core/macro';
import { useMemo } from 'react';
import { useIsPartner } from '../../../features/referral/hooks/usePartnerProgram.ts';
import useAppStore from '../../../store/rootStore.ts';
import { PARTNER_NAV_LABEL } from '../constants';
import { type RewardsMenuItem, rewardsMenuItems } from './config.tsx';

const PARTNER_REWARDS_DESCRIPTION = msg({
  comment: 'Rewards menu description for the partner (VIP Rewards) entry replacing Referrals',
  message: 'Partner rewards dashboard',
});

/** Same feature gates and partner relabel as the nav tabs / mobile drawer. */
export function useFilteredRewardsMenuItems(): readonly RewardsMenuItem[] {
  const rewardsEnabled = useAppStore((state) => state.config?.features.rewardsEnabled);
  const pointsEnabled = useAppStore((state) => state.config?.features.pointsEnabled);
  const referralDashboardEnabled = useAppStore((state) => state.config?.features.referralDashboardEnabled);
  const isPartner = useIsPartner();

  return useMemo(() => {
    const flags: Record<RewardsMenuItem['feature'], boolean> = {
      rewardsEnabled: Boolean(rewardsEnabled),
      pointsEnabled: Boolean(pointsEnabled),
      referralDashboardEnabled: Boolean(referralDashboardEnabled),
    };

    return rewardsMenuItems
      .filter((item) => flags[item.feature])
      .map((item) =>
        item.key === 'referrals' && isPartner
          ? { ...item, label: PARTNER_NAV_LABEL, description: PARTNER_REWARDS_DESCRIPTION }
          : item
      );
  }, [rewardsEnabled, pointsEnabled, referralDashboardEnabled, isPartner]);
}
